import { Card, CardContent, Typography, Box, Divider } from "@mui/material";
import { Job } from "@api/Models";
import { ProjectCard } from "./ProjectCard";

interface JobCardProps {
  job: Job;
}

export function JobCard({ job }: JobCardProps) {
  return (
    <Card className="mb-6 hover:shadow-2xl">
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5" component="div">
            {job.title}
          </Typography>
          <Typography color="text.secondary" gutterBottom>
            {job.company}
          </Typography>
        </Box>
        <Typography color="text.secondary" gutterBottom>
          {job.start_date} - {job.end_date}
        </Typography>
        <Divider />
        {job.projects.map((project, index) => (
          <ProjectCard key={index} project={project} />
        ))}
      </CardContent>
    </Card>
  );
}
